export default "__VITE_ASSET__DBvYC09X__"